export default {
  created() {
  },
  data() {
    return {
      submitLoading: false,
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 },
        offsetCol: { span: 18, offset: 5 }
      },
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
        offsetCol: { span: 18, offset: 6 }
      },
      currentFormLayout2: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
        offsetCol: { span: 19, offset: 4 }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 6 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 18 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      uploadFileUrl: this.getUploadFileUrl()//图片上传地址
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'TiktokProductSync', title: '商品同步' },
      { name: 'TiktokOrderList', title: '订单直连' },
      { name: 'TiktokStores', title: '关联店铺' }
    ])
  },
  methods: {
    //获取图片上传地址
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    },
    handleBeforeUploadImage(file) {
      this.getLogUtils().logWithTag('handleBeforeUploadImage', file)
      // 限制图片 格式、size、分辨率
      const isJPG = file.type === 'image/jpeg'
      const isJPEG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      if (!(isJPG || isJPEG || isPNG)) {
        this.$message.error('上传图片的格式不正确，不是JPG、JPEG、PNG')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传的文件不能大于2M!')
        return false
      }
      return true
    },
    getLatestUrlFromFileList(fileList) {
      if (fileList && fileList.length > 0) {
        const lastIndex = fileList.length - 1
        if (fileList[lastIndex] && fileList[lastIndex].response) {
          return fileList[lastIndex].response.data
        }
      }
      return ''
    }
  }
}